import React, { useCallback, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';

import MoreVertIcon from '@mui/icons-material/MoreVert';

import Skeleton from '@mui/material/Skeleton';

import ListItemSelectionMark from '@ts-core/components/ListItemSelectionMark';

import withConfirmAction from '@ts-core/components/HOC/withConfirmAction';

const GroupListItem = (props) => {
  const {
    group,
    loading,
    selected,
    onSelectGroup,
    showSelectedMark,
    canBeDeleted,
    onEditGroup,
    onRemoveGroup,
    handleConfirmAction,
  } = props;

  const menuButtonRef = useRef();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleOpenMenu = useCallback(() => {
    setMenuOpen(true);
  }, []);

  const handleCloseMenu = useCallback(() => {
    setMenuOpen(false);
  }, []);

  const handleSelect = useCallback(() => {
    onSelectGroup(group);
    handleCloseMenu();
  }, [group, onSelectGroup, handleCloseMenu]);

  const handleEdit = useCallback(() => {
    onEditGroup(group);
    handleCloseMenu();
  }, [onEditGroup, group, handleCloseMenu]);

  const handleRemove = useCallback(() => {
    handleCloseMenu();
    handleConfirmAction(onRemoveGroup, group, {
      id: 'dialog.confirmRemoveItem.title',
      values: { item: group.name },
    });
  }, [handleCloseMenu, onRemoveGroup, handleConfirmAction, group]);

  return (
    <ListItem button onClick={handleSelect}>
      {showSelectedMark && selected && <ListItemSelectionMark />}
      {loading ? (
        <Skeleton width={160} height={30} />
      ) : (
        <ListItemText primary={group.name} style={{ paddingLeft: 0 }} />
      )}
      <ListItemSecondaryAction>
        <IconButton onClick={handleOpenMenu} ref={menuButtonRef} size="large">
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="subject-menu"
          anchorEl={menuButtonRef.current}
          open={menuOpen}
          onClose={handleCloseMenu}
        >
          <MenuItem onClick={handleEdit}>
            <FormattedMessage id="button.edit.label" />
          </MenuItem>
          {canBeDeleted ? (
            <MenuItem onClick={handleRemove}>
              <FormattedMessage id="button.remove.label" />
            </MenuItem>
          ) : null}
        </Menu>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

GroupListItem.propTypes = {
  group: PropTypes.object,
  loading: PropTypes.bool,
  selected: PropTypes.bool,
  showSelectedMark: PropTypes.bool,

  onSelectGroup: PropTypes.func.isRequired,
  onEditGroup: PropTypes.func.isRequired,
  onRemoveGroup: PropTypes.func.isRequired,

  handleConfirmAction: PropTypes.func.isRequired,
  canBeDeleted: PropTypes.bool.isRequired,
};

GroupListItem.defaultProps = {
  group: {},
  loading: false,
  selected: false,
  showSelectedMark: false,
};

export default withConfirmAction(GroupListItem);
